import { Anchor, Center, Flex } from "@mantine/core";

import { IconReportMedical } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";
import PermissionGate from "@/permission/components/PermissionGate";
import { PROVIDER_BILLER_SCRIBE_PERMISSION_FLAGS } from "@/permission/constants/practitioner-permissions";

interface EmptyDiagnosesListProps {
  handleOpenDiagnosisDrawer: () => void;
  canEditDiagnoses: boolean;
}

export default function EmptyDiagnosesList({
  handleOpenDiagnosisDrawer,
  canEditDiagnoses,
}: EmptyDiagnosesListProps) {
  return (
    <Center pb="lg">
      <Flex
        h={40}
        gap="sm"
        w="100%"
        bg="gray.0"
        align="center"
        justify="center"
        style={{ borderRadius: "var(--mantine-radius-xs)" }}
      >
        <IconReportMedical size={18} color="var(--mantine-color-gray-6)" />
        <TextWrapper fz="sm" c="gray.7" variant="default">
          {"No diagnosis has been added. "}
          {canEditDiagnoses && (
            <PermissionGate requiredPermissions={PROVIDER_BILLER_SCRIBE_PERMISSION_FLAGS}>
              <Anchor
                fw={600}
                c="gray.7"
                underline="always"
                style={{ userSelect: "none" }}
                onClick={handleOpenDiagnosisDrawer}
              >
                Add Diagnosis
              </Anchor>
            </PermissionGate>
          )}
        </TextWrapper>
      </Flex>
    </Center>
  );
}
